import { useState, useMemo, useCallback } from "react";
import DashboardHeader from "../../../components/dashboard/dashboardHeader";
import { useUserHasAccess } from "../../../routes/roleOnly";
import { WorkOrderStacklist } from "../../../components/dashboard/workOrders/work-order-stacklist";
import { PlusIcon, CheckBadgeIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";

export const WorkOrderList = () => {
  const { t } = useTranslation();

  const [listStats, setListStats] = useState({
    totalCount: null,
    currentCount: null,
  });

  const handleStatsChange = useCallback((next) => {
    setListStats((prev) => {
      if (
        prev.totalCount === next.totalCount &&
        prev.currentCount === next.currentCount
      ) {
        return prev;
      }
      return next;
    });
  }, []);

  const headerMeta = useMemo(
    () => [
      {
        label:
          listStats.totalCount != null
            ? t("work_orders.list_meta_total", {
                count: listStats.totalCount,
              })
            : "—",
        description: "",
        path: null,
        action: null,
        icon: CheckBadgeIcon,
        textColor: "text-gray-400",
        iconColor: "text-gray-400",
        hidden: false,
      },
    ],
    [listStats.totalCount, t]
  );

  const canCreateWorkOrder = useUserHasAccess({
    role: "projects_work-orders",
    action: "create",
  });

  const createButton = canCreateWorkOrder
    ? {
        label: t("New Work Order"),
        path: "/dashboard/work_orders/new",
        color: "",
        icon: PlusIcon,
      }
    : null;

  return (
    <>
      <DashboardHeader
        subtitle=""
        title={t("Work Order List")}
        meta={headerMeta}
        mainButton={createButton}
        actions={[]}
      >
        <div className="mx-auto mt-8 grid min-w-0 max-w-3xl grid-cols-1 gap-6 sm:px-6 lg:max-w-7xl lg:grid-flow-col-dense lg:grid-cols-3">
          <WorkOrderStacklist onStatsChange={handleStatsChange} />
        </div>
      </DashboardHeader>
    </>
  );
};
